import Highcharts from "highcharts/highcharts";
import HighchartsMore from "highcharts/highcharts-more";
import SolidGuage from "highcharts/modules/solid-gauge";

class GaugeChartController {
  constructor($scope) {
    "ngInject";

    //Begin Services
    this.$scope = $scope;
    //End Services

    //Begin Data
    this.hasNoTarget = false;
    this.chartContainerId = `chartContainer${this.getGuid()}`
    this.chart = null;
    //End Data

    //Begin Initialize
    this.$onChanges = (changesObj) => {
      if (changesObj.eventId.currentValue) {
        this.$scope.$on(`kpiAnalytics:targetsOverviewUpdated.${changesObj.eventId.currentValue}`, this.refresh.bind(this));
      }
    }

    //Init Highcharts and Modules
    HighchartsMore(Highcharts);
    SolidGuage(Highcharts);

    //End Initialize 
  } 

  refresh(evt, params) {
    if (this.chart){
      this.chart.destroy();
    }

    if (!params.target) {
      this.hasNoTarget = true;
    }
    else {
      this.hasNoTarget = false;
      this.generateChart(params.target, params.achieved);
    }    
  }

  generateChart(target, achieved) {
    const limit1 = target;
    const limit2 = limit1 + (limit1 * 0.3);

    //Chart Code Start     
    const gaugeOptions = {
      chart: {
        type: 'gauge',
      },      
      title: null,      
      pane: {
        center: ['50%', '85%'],
        size: '150%',
        startAngle: -90,
        endAngle: 90,
        background: {
          innerRadius: '60%',
          outerRadius: '100%',
          shape: 'arc'
        }
      },      
      tooltip: {
        enabled: false
      },      
      yAxis: {
        lineWidth: 0,
        minorTickInterval: null,
        tickPixelInterval: 400,
        tickWidth: 0,
        labels: {
          y: 16,
          color: '#FFF'
        }        
      }        
    };

    const chartOptions = {
      yAxis: {
        min: 0,
        max: limit2,
        title: {
          text: null
        },
        plotBands: [
          {
            from: 0,
            to: limit1,
            color: '#f7e065',
            innerRadius: '60%'
          }, {
            from: limit1,
            to: limit2,
            innerRadius: '60%',
            color: '#5cd65c' // yellow
          }]  
        },
        credits: {
          enabled: false
        },
        series: [
          {
            data: [{y: achieved}],
            dataLabels: {
              enabled: true
            },
          }
        ]
    };
    
    // The speed gauge
    return Highcharts.chart(this.chartContainerId, Highcharts.merge(gaugeOptions, chartOptions));                                      
    
    //Chart Code End
  }

  getGuid() {
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}

export default GaugeChartController;



// WEBPACK FOOTER //
// ./client/app/components/common/gaugeChart/gaugeChart.controller.js